import AppointmentInfo from './AppointmentInfo';
import fragment from './fragment';

export default AppointmentInfo;
export { fragment };
